import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=cfad48fe&scoped=true"
import script from "./DashboardProjects.vue?vue&type=script&lang=js"
export * from "./DashboardProjects.vue?vue&type=script&lang=js"
import style0 from "./DashboardProjects.vue?vue&type=style&index=0&id=cfad48fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfad48fe",
  null
  
)

export default component.exports